module.exports = __webpack_public_path__ + "static/media/img6.7ffbb961.png";